import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PublicLayout } from './components/PublicLayout';
import { Home } from './pages/Home';
import { Activities } from './pages/Activities';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfUse } from './pages/TermsOfUse';
import { Amendments } from './pages/Amendments';
import { AmendmentDetail } from './pages/AmendmentDetail';

import { AdminLayout } from './admin/layouts/AdminLayout';
import { Dashboard } from './admin/pages/Dashboard';
import { EmendasList } from './admin/pages/EmendasList';
import { EmendaForm } from './admin/pages/EmendaForm';
import { Settings } from './admin/pages/Settings';

import { CookieBanner } from './components/CookieBanner';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/atividades" element={<Activities />} />
          <Route path="/sobre-nos" element={<About />} />
          <Route path="/contato" element={<Contact />} />
          <Route path="/emendas" element={<Amendments />} />
          <Route path="/emendas/:id" element={<AmendmentDetail />} />
          <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
          <Route path="/termos-de-uso" element={<TermsOfUse />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="emendas" element={<EmendasList />} />
          <Route path="emendas/nova" element={<EmendaForm />} />
          <Route path="emendas/editar/:id" element={<EmendaForm />} />
          <Route path="configuracoes" element={<Settings />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <CookieBanner />
    </BrowserRouter>
  );
}
